window.addformErrorCache = {};

function isErrorAlreadyInCache(message) {
  return Boolean(window.addformErrorCache[message]);
}

function saveErrorToCache(message) {
  window.addformErrorCache[message] = 1;
}

function isErrorCacheCountReached(message, cacheCountLimit) {
  return window.addformErrorCache[message] % cacheCountLimit === 0;
}

function increaseCacheCount(message) {
  window.addformErrorCache[message] += 1;
}

function getErrorCacheCount(message) {
  return window.addformErrorCache[message];
}

function getMetaWithErrorCount(meta, count) {
  return {
    stacktrace: meta.stacktrace,
    cachedErrorCount: count,
  };
}

function logErrorWithExtendedMeta(logger, message, meta) {
  logger.error(message, getMetaWithErrorCount(meta, getErrorCacheCount(message)));
}

export function error(logger, message, meta, { cacheCountLimit }) {
  if (isErrorAlreadyInCache(message)) {
    if (isErrorCacheCountReached(message, cacheCountLimit)) {
      logErrorWithExtendedMeta(logger, message, meta);
    }

    increaseCacheCount(message);
  } else {
    saveErrorToCache(message);

    logErrorWithExtendedMeta(logger, message, meta);
  }
}
